import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { alpha, Box, Button } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UseTranslation from '../../hooks/UseTranslation'

const LoadMore = ({ actionToDispatch, store }) => {
  const dispatch = useDispatch()
  const pageNumber = store.pageNumber + 1
  const moreBtn = useRef(null)
  const { t } = UseTranslation()
  useEffect(() => {
    window.onscroll = function () {
      if (
        document.body.offsetHeight - window.innerHeight < window.scrollY &&
        store.pageNumber < 2 && !store.loading
      ) {
        moreBtn.current.click()
      }
    }
  }, [store])

  const retrieveData = () => {
    dispatch(
      actionToDispatch({
        queries: {
          pageNumber,
          activeSummary: store.activeSummary,
          activeSearch: store.activeSearch,
        },
      }),
    )
  }

  return !store.finalPage ? (
    <Button
      sx={styles.loadMoreButton}
      disabled={!!store.loading}
      onClick={retrieveData}
      ref={moreBtn}>
        {t?.['Load More']}
      <KeyboardArrowDownIcon />
    </Button>
  ) : (
    !store.loading && (
      <Box sx={styles.noMoreResultContainer}>
          <span style={styles.noMoreResult}>
             {t?.['No More Results']}
        </span>
      </Box>
    )
  )
}

const styles = {
  loadMoreButton: {
    backgroundColor: 'white',
    width: '100%',
    borderRadius: '10px',
    boxShadow: '0 0 2px 0 rgba(188, 188, 212, 0.4)',
    padding: { xs: '10px', sm: '20px' },
    marginBottom: '10px',
    position: 'relative',
    display: 'flex',
    fontWeight: 'typography.fontWeightBold',
    color: 'primary.main',
    textTransform: 'none',
    '&:hover, &:focus': {
      color: alpha('#29cc8b', 0.75),
    },
  },
  noMoreResultContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  noMoreResult: {
    display: 'block',
    textAlign: 'center',
    color: 'grey',
    marginBottom: { xs: '10px', sm: '20px' },
  },
}

export default LoadMore
